import { useEffect, useState } from 'react'

/**
 * Track viewport width — returns 'mobile' | 'tablet' | 'desktop' bucketed at
 * standard breakpoints. Used by App shell to decide sidebar vs. bottom nav.
 */
export type ViewportBucket = 'mobile' | 'tablet' | 'desktop'

const BREAKPOINT_TABLET = 768
const BREAKPOINT_DESKTOP = 1024

function bucketFor(w: number): ViewportBucket {
  if (w >= BREAKPOINT_DESKTOP) return 'desktop'
  if (w >= BREAKPOINT_TABLET) return 'tablet'
  return 'mobile'
}

export function useViewport(): ViewportBucket {
  const [bucket, setBucket] = useState<ViewportBucket>(() =>
    typeof window === 'undefined' ? 'mobile' : bucketFor(window.innerWidth))

  useEffect(() => {
    if (typeof window === 'undefined') return
    const handler = () => setBucket(bucketFor(window.innerWidth))
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return bucket
}
